import { getSlideWidthAndHeight, getAnimDuration, getTnRotate, isRightAnimType } from '../utils';
import { AnimType } from '@tencent/slide-sdk-model';
// 飞旋
interface ValueType {
    value: number,
    duration: number,
}
interface ToStyleType {
    opacity: number | ValueType[],
    scaleX: ValueType[],
    scaleY: number | ValueType[],
    translateX: ValueType[],
    translateY: ValueType[],
    rotate: ValueType[],
}
export const getEntrBoomerangToStyle = (timeNode, playMode) => {
    if (!isRightAnimType(timeNode, playMode, AnimType.EntrBoomerang)) return {};
    const objRotate = getTnRotate(timeNode);
    const duration = getAnimDuration(timeNode, playMode);
    const { slideHeight } = getSlideWidthAndHeight(timeNode, playMode);
    const moveDur = 0.5 * duration;
    const tempToStyle: ToStyleType = {
        opacity: 1,
        scaleX: [
            { value: 0.05, duration: moveDur },
            { value: 1, duration: moveDur },
        ],
        scaleY: 1,
        translateX: [
            { value: 0, duration: moveDur },
            { value: 0, duration: moveDur },
        ],
        translateY: [
            { value: 0.1 * slideHeight, duration: moveDur },
            { value: 0, duration: moveDur },
        ],
        rotate: [
            { value: objRotate, duration: moveDur },
            { value: objRotate, duration: moveDur },
        ],
    };
    tempToStyle.opacity = [
        { value: 0.5, duration: moveDur },
        { value: 1, duration: moveDur },
    ];
    return tempToStyle;
};

export const getExitBoomerangToStyle = (timeNode, playMode) => {
    if (!isRightAnimType(timeNode, playMode, AnimType.ExitBoomerang)) return {};
    const objRotate = getTnRotate(timeNode);
    const duration = getAnimDuration(timeNode, playMode);
    const { slideWidth, slideHeight } = getSlideWidthAndHeight(timeNode, playMode);
    const moveDur = 0.5 * duration;
    const tempToStyle: ToStyleType = {
        opacity: 0,
        scaleX: [
            { value: 0.05, duration: moveDur },
            { value: 1.5, duration: moveDur },
        ],
        scaleY: [
            { value: 1, duration: moveDur },
            { value: 1.5, duration: moveDur },
        ],
        translateX: [
            { value: 0, duration: moveDur },
            { value: 0.4 * slideWidth, duration: moveDur },
        ],
        translateY: [
            { value: 0.1 * slideHeight, duration: moveDur },
            { value: -0.1 * slideHeight, duration: moveDur },
        ],
        rotate: [
            { value: objRotate, duration: moveDur },
            { value: -90 + objRotate, duration: moveDur },
        ],
    };
    tempToStyle.opacity = [
        { value: 0.5, duration: moveDur },
        { value: 0, duration: moveDur },
    ];
    return tempToStyle;
};
